import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { BuscadorPipe } from '../../pipes/buscador.pipe';
import { Observable } from 'rxjs/Observable';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { Subscription } from 'rxjs/Subscription';
import { ItemSolicitudesDisponiblesListado } from '../itemClasses/itemListadoSolicitudesDisponibles.class';

@Component({
    selector: 'listado-SolicitudesDisponibles',
    templateUrl: './aviableSolicitudeList.component.html',
    providers: [BuscadorPipe]
})
export class ListadoSolicitudDisponibleComponent implements OnInit, OnDestroy {
  @Output() clickNuevo: EventEmitter<any> = new EventEmitter();
  @Output() toogleStatus: EventEmitter<any> = new EventEmitter();
  @Input('listado') listado: Observable<ItemSolicitudesDisponiblesListado[]>;
  @Input('titulo') titulo: String;
  @Input('urladicional') urladicional: String = '';
  @Input('leyendaListado') leyendaListado: String = '';
  @Input('ocultarNuevo') ocultarNuevo = false;
  listadoNoFiltrado: ItemSolicitudesDisponiblesListado[];
  listadoFiltrado: ItemSolicitudesDisponiblesListado[];
  buscarListado: String = '';
  itemHover: ItemSolicitudesDisponiblesListado;
  subscripcion: Subscription;
  paginador: any = {};
  items: ItemSolicitudesDisponiblesListado[] = new Array<ItemSolicitudesDisponiblesListado>();
  private allItems: any[];
  cargando = false;
  constructor() { }

  ngOnInit() {
    this.cargando = true;
    this.subscripcion = this.listado.subscribe(data => {
      this.listadoNoFiltrado = data;
      this.filtrarListado();
      this.cargando = false;
    });
  }

  ngOnDestroy() {
    this.subscripcion.unsubscribe();
  }

  /**
   * Funcion que se llama cuando el boton Nuevo es clickeado,
   * el proposito de esta funcion es propagar dicho evento
   * para que pueda ser capturado por algun componente padre.
   */
  onClickNuevo() {
    this.clickNuevo.emit();
  }

  onToogleStatus(item: ItemSolicitudesDisponiblesListado) {
    this.toogleStatus.emit(item);
  }

  filtrarListado() {
    this.listadoFiltrado = this.listadoNoFiltrado
      .filter(item => item.Titulo.toUpperCase().indexOf(this.buscarListado.toUpperCase()) !== -1);

    this.setPage(1);
  }
  setPage(nroPagina: number) {
    this.cargando = true;
    this.paginador = this.getPager(this.listadoFiltrado.length, nroPagina);
    if (nroPagina < 1 || (nroPagina > this.paginador.totalPaginas && this.paginador.totalPaginas !== 0)) {
        return;
    }
    this.items = this.listadoFiltrado.slice(this.paginador.startIndex, this.paginador.endIndex + 1);
    this.cargando = false;
  }
  getPager(totalItems: number, paginaActual: number = 1, catidadPorPagina: number = 9) {
      const totalPaginas = Math.ceil(totalItems / catidadPorPagina);

      let startPagina: number, endPagina: number;
      if (totalPaginas <= 10) {
          startPagina = 1;
          endPagina = totalPaginas;
      } else {
          if (paginaActual <= 6) {
              startPagina = 1;
              endPagina = 10;
          } else if (paginaActual + 4 >= totalPaginas) {
              startPagina = totalPaginas - 9;
              endPagina = totalPaginas;
          } else {
              startPagina = paginaActual - 5;
              endPagina = paginaActual + 4;
          }
      }

      // Calcular los índices de elementos iniciales y finales
      const startIndex = (paginaActual - 1) * catidadPorPagina;
      const endIndex = Math.min(startIndex + catidadPorPagina - 1, totalItems - 1);

      // create an array of pages to ng-repeat in the pager control
      const paginas: number[] = new Array();
      for (let index = startPagina; index < endPagina + 1; index++) {
          paginas.push(index);
      }

      // return object with all pager properties required by the view
      return {
          totalItems: totalItems,
          paginaActual: paginaActual,
          catidadPorPagina: catidadPorPagina,
          totalPaginas: totalPaginas,
          startPagina: startPagina,
          endPagina: endPagina,
          startIndex: startIndex,
          endIndex: endIndex,
          paginas: paginas
      };
  }

  toogleItem(item: ItemSolicitudesDisponiblesListado) {
    const solicitud = this.listadoNoFiltrado.find(elem => elem.Codigo === item.Codigo);
    if (!!solicitud) {
      solicitud.UtilizadoEnNivel = !solicitud.UtilizadoEnNivel;
    }
  }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/aviableSolicitudeList/aviableSolicitudeList.component.ts